import { Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from '@base/environments/environment';
import { QRInputAutocomplete } from '@base/src/app/models/qr-input-autocomplete.model';
import { UtilsService } from '@base/src/app/services/utils.service';
import * as moment from 'moment';
import { Constants } from 'src/app/models/constants';
import { QRButton } from 'src/app/models/qr-button.model';
import { QRDialog } from 'src/app/models/qr-dialog.model';
import { QRDropdown } from 'src/app/models/qr-dropdown.model';
import { QRInput } from 'src/app/models/qr-input.model';
import {
  EnabledTeamLeader,
  MemberTeam,
  NewTeam,
} from 'src/app/models/rrhh.model';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-rrhh-team-info-form',
  templateUrl: './rrhh-team-info-form.component.html',
  styleUrls: ['./rrhh-team-info-form.component.scss'],
})
export class RrhhTeamInfoFormComponent {
  @Input() teamLeaderList: EnabledTeamLeader[] = [];
  @Input() readyData = false;
  @Input() dataForServiceInfo!: NewTeam;
  @Output() disabledButtonContinue: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Input() isEdit!: boolean;

  todayDate: string = moment().format('YYYY-MM-DD');

  completedData: any = {
    teamName: false,
    teamLeader: false,
  };

  inputName: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Nombre',
  };

  inputAutocompleteTeamLeader: QRInputAutocomplete = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Nombre del agente',
    isCleanButtonVisible: true,
    options: [],
  };

  buttonAddPhoto: QRButton = {
    hierarchy: QRButton.HIERARCHY_2,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Agregar foto',
    icon: Constants.ICONS.ADD_PHOTO,
  };

  teamName = '';
  idTeamLeaderSelected: number | undefined;
  nameTeamLeaderSelected: string | undefined;
  setUniqueQrTeamId: number | null = null;

  //File Photo
  uploadedFileStatus = false; //==> El archivo se subió?
  uploadedFile: File | undefined; //==> archivo subido
  fileB64 = ''; //==> archivo en base64 para POST
  fileName = '';
  previewImageUrl = '';
  allowedFormats = ['image/jpeg', 'image/jpg', 'image/png'];
  buttonDeleteFile: QRButton = {
    hierarchy: QRButton.HIERARCHY_4,
    size: QRButton.SIZE_SMALL,
    icon: Constants.ICONS.CLOSE,
    iconOnly: true,
  };

  dialogImportTeam: QRDialog = {
    isVisible: false,
    width: '744px',
    height: '370px',
    title: 'Team Leader seleccionado',
    textButtonAction: 'Si, vincular',
    textButtonCancel: 'No, crear un nuevo team',
    isNotCloseable: true,
    componentToLoad: QRDialog.DIALOG_RRHH_IMPORT_TEAM,
    value: { teamName: '', leaderName: '' },
  };

  readonly NODE_DO = Constants.TENANT_ID_DO;
  readonly NODE = environment.node;
  readonly NODE_AR = Constants.TENANT_ID_AR;
  readonly NODE_EC = Constants.TENANT_ID_EC;

  constructor(
    private readonly snackbarService: SnackbarService,
    private readonly utilsService: UtilsService,
  ) {}

  ngOnChanges() {
    setTimeout(() => {
      if (this.readyData) {
        if (!this.isEdit) {
          if (this.teamLeaderList && this.teamLeaderList.length > 0) {
            const LIST_DROPDOWN: string[] = [];

            this.teamLeaderList.forEach((e) => {
              const NAME = e.name + ' ' + e.lastname;
              LIST_DROPDOWN.push(NAME);
            });

            this.inputAutocompleteTeamLeader = {
              ...this.inputAutocompleteTeamLeader,
              options: LIST_DROPDOWN,
            };
          }
        }

        const LEADER = this.dataForServiceInfo.members.find((e) => e.leader);
        if (LEADER) {
          this.nameTeamLeaderSelected = LEADER.name + ' ' + LEADER.lastname;
          this.completedData.teamLeader = true;

          this.inputAutocompleteTeamLeader = {
            ...this.inputAutocompleteTeamLeader,
            isCleanButtonVisible: false,
          };
        }

        if (this.dataForServiceInfo.photo) {
          this.previewImageUrl = this.dataForServiceInfo.photo;
          this.fileB64 = this.dataForServiceInfo.photo;
          this.uploadedFileStatus = true;
        }

        if (this.dataForServiceInfo.photoName) {
          this.fileName = this.utilsService.sanitizeFileName(
            this.dataForServiceInfo.photoName,
          );
        }

        if (this.dataForServiceInfo.nameTeam) {
          this.teamName = this.dataForServiceInfo.nameTeam;
          this.completedData.teamName = true;
        }

        this.checkForm();
      }
    }, 1);
  }

  changeTeamName($event: any) {
    if ($event) {
      this.teamName = $event;
      this.dataForServiceInfo.nameTeam = this.teamName;
      this.completedData.teamName = true;
    } else {
      this.completedData.teamName = false;
    }
    this.checkForm();
  }

  changeTeamLeaderName(selected: string | undefined) {
    this.teamLeaderList.forEach((e) => {
      if (e.name + ' ' + e.lastname == selected) {
        e.uniqueQrTeamId != null && this.openDialogImportTeam(e.uniqueQrTeamId);
        this.idTeamLeaderSelected = e.id;
        this.nameTeamLeaderSelected = selected;
        this.dialogImportTeam.value.teamName = e.teamName;
        this.dialogImportTeam.value.leaderName = selected;
        if (this.NODE === this.NODE_DO) {
          this.dataForServiceInfo.agentTypeKey = e.agentTypeKey;
        }
        const memberLeader: MemberTeam = {
          id: e.id,
          startDate: this.todayDate,
          endDate: '',
          lastname: e.lastname,
          name: e.name,
          leader: true,
          isNew: true,
        };
        const existingLeaderIndex = this.dataForServiceInfo.members.findIndex(
          (e) => e.leader,
        );
        if (existingLeaderIndex == -1) {
          this.dataForServiceInfo.members.push(memberLeader);
        } else {
          this.dataForServiceInfo.members[existingLeaderIndex] = memberLeader;
        }
      }
    });
    this.completedData.teamLeader = true;
    this.checkForm();
  }

  getImgDimensions(file: File): Promise<{ width: number; height: number }> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        const img = new Image();
        img.src = event?.target?.result as string;
        img.onload = () => {
          const width = img.width;
          const height = img.height;
          resolve({ width, height });
        };
      };
      reader.readAsDataURL(file);
    });
  }

  async addFile($event: any) {
    this.uploadedFile = $event.target.files[0];
    const reader = new FileReader();
    let isValidSize = false;
    let isValidType = false;
    let isValidDimension = false;

    if (this.uploadedFile) {
      isValidSize = this.uploadedFile.size <= 2 * 1024 * 1024;
      isValidType = this.allowedFormats.includes(this.uploadedFile.type);
      if (isValidType) {
        //Valida dimensión de la imagen
        await this.getImgDimensions(this.uploadedFile).then((dimensions) => {
          isValidDimension =
            dimensions.height <= 600 && dimensions.width <= 600;
        });
      }

      if (!isValidType || !isValidSize || !isValidDimension) {
        this.snackbarService.openSnackBar(
          '⛔ Solo imágenes de hasta 2MB y 600 x 600px o menos',
          '',
        );
      } else {
        this.fileName = this.utilsService.sanitizeFileName(
          this.uploadedFile.name,
        );
        this.dataForServiceInfo.photoName = this.fileName;

        reader.onloadend = () => {
          const result = reader.result as string;
          this.fileB64 = result;
          this.previewImageUrl = result;
          this.dataForServiceInfo.photo = this.fileB64;
        };

        reader.readAsDataURL(this.uploadedFile);
        this.uploadedFileStatus = true;
        this.completedData.photo = true;
        this.checkForm();
      }
    }
  }

  deleteFile() {
    this.uploadedFile = undefined;
    this.uploadedFileStatus = false;
    this.dataForServiceInfo.photo = '';
    this.checkForm();
  }

  checkForm() {
    let allDataCompleted = true;

    //En Ecuador no existen los team leader, esta validacion es siempre verdadera
    if (this.NODE == this.NODE_EC) {
      this.completedData.teamLeader = true;
    }

    Object.keys(this.completedData).forEach((key: any) => {
      allDataCompleted = allDataCompleted && this.completedData[key];
    });

    this.disabledButtonContinue.emit(allDataCompleted);
  }

  //Se toma el uniqueQrTeamId del leader encontrado y se guarda en su nuevo team
  dialogImportTeamChange(event: any): void {
    this.dataForServiceInfo.uniqueQrTeamId = this.setUniqueQrTeamId;
    this.dialogImportTeam.isNotCloseable = false;
  }

  openDialogImportTeam(uniqueQrId: number): void {
    this.dialogImportTeam = {
      ...this.dialogImportTeam,
      isVisible: true,
    };
    this.setUniqueQrTeamId = uniqueQrId;
  }
}
